import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import InputMask from 'react-input-mask';
import CmsContext from 'context/CmsContext';
import Select from 'react-select';
import { reactSelectCustomStyleCms } from 'helper';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import * as actions from '../actions';
import * as c from '../constant';

function AddRecordModal({
  createRecord,
  getList,
  history,
  creating,
  type,
  updateRecord,
  dataInfo,
  id,
}) {
  const [formData, setFormData] = useState({
    tdn: '',
    pin: '',
    year: '',
    account_number: '',
    account_name: '',
    date_processed: '',
    expiration_date: '',
    amount: '',
    is_delinquent: 0,
    is_overwrite: 0,
  });
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');

  const setModal = useContext(ModalContext);

  const [pinFormat, setPinFormat] = useState(false);

  const getCurrentYear = () => `${new Date().getFullYear()}`;

  const getYearsList = (start = getCurrentYear(), endOffset = 50) => {
    let y = [];
    for (let i = start; i > start - endOffset; i -= 1) {
      y = y.concat([
        {
          label: `${i}`,
          value: i,
        },
      ]);
    }
    return y;
  };

  let commonValidation = {
    tdn: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_TDN_REGEX_CSV')}~${_.get(
      CMS_MASKINGS,
      'RPTAX_TDN_CSV'
    )}`,
    pin: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_PIN_REGEX_CSV')}~${_.get(
      CMS_MASKINGS,
      'RPTAX_PIN_CSV'
    )}`,
    year: 'required',
    account_number: `required|mask:${_.get(
      CMS_MASKINGS,
      'RPTAX_TDN_REGEX_CSV'
    )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
    account_name: 'required',
    date_processed: 'required',
    expiration_date: 'required',
    amount: 'required|amount',
  };

  if (!_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT')) {
    commonValidation = {
      ...commonValidation,
      tdn: 'required|rptax_tdn',
      account_number: 'required|rptax_tdn',
    };
  }

  const validateForm = useFormValidator(formData, commonValidation);

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    if (pinFormat === false) {
      commonValidation = {
        ...commonValidation,
        account_number: `required|mask:${_.get(
          CMS_MASKINGS,
          'RPTAX_TDN_REGEX_CSV'
        )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
        tdn: `required|mask:${_.get(
          CMS_MASKINGS,
          'RPTAX_TDN_REGEX_CSV'
        )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
        pin: `required|mask:${_.get(
          CMS_MASKINGS,
          'RPTAX_PIN_REGEX_CSV'
        )}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}`,
      };
      validateForm.onSetObjectRules(commonValidation);
    }
    if (pinFormat) {
      commonValidation = {
        ...commonValidation,
        account_number: `required|mask:${_.get(
          CMS_MASKINGS,
          'RPTAX_TDN_REGEX_CSV'
        )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
        tdn: `required|mask:${_.get(
          CMS_MASKINGS,
          'RPTAX_TDN_REGEX_CSV'
        )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
        pin: `required|mask:${_.get(
          CMS_MASKINGS,
          'RPTAX_PIN_REGEX_2_CSV'
        )}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV')}`,
        // pin: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_PIN_REGEX_2')}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}`
      };
      validateForm.onSetObjectRules(commonValidation);
    }
  }, [pinFormat]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handlePinFormat = e => {
    if (e.target.checked) {
      setPinFormat(true);
    } else {
      setPinFormat(false);
    }
  };

  const handleOnChange = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });

    // Note: this condition has been moved to SOA Amount input field as per <NumberFormat /> requirements
    // const isDecimal =
    //   e.target.value && /^\d{1,}(\.\d{0,4})?$/.test(e.target.value);

    // if (isDecimal && key === 'amount') {
    //   setFormData({
    //     ...formData,
    //     amount: e.target.value,
    //     first_quarter: (parseFloat(e.target.value) * parseFloat(.25)),
    //     second_quarter: (parseFloat(e.target.value) * parseFloat(.50)),
    //     third_quarter: (parseFloat(e.target.value) * parseFloat(.75)),
    //     fourth_quarter: e.target.value,
    //   });
    // }
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    const args = {
      ...formData,
      date_processed: `${moment(_.get(formData, 'date_processed')).format(
        'YYYY-MM-DD'
      )}`,
      expiration_date: `${moment(_.get(formData, 'expiration_date')).format(
        'YYYY-MM-DD'
      )}`,
      amount: parseInt(_.get(formData, 'amount').replace(/,/g, ''), {}),
    };
    if (type === 'ADD') {
      createRecord(args, () => {
        setModal({ isOpen: false });
        getList({
          overwrite_previous: 0,
          is_active: 1,
        });
        history.push(`/billing/rptax`);
      });
    }

    if (type === 'EDIT') {
      updateRecord(id, args, () => {
        setModal({ isOpen: false });
        getList({
          overwrite_previous: 0,
          is_active: 1,
        });
        history.push(`/billing/rptax`);
      });
    }
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    if (key === 'year') {
      setFormData({
        ...formData,
        [key]: e ? e.value : '',
        mode_of_payment_1: `${e.value}-1`,
        mode_of_payment_2: `${e.value}-4`,
      });
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      const splitStr = dataInfo.pin.replace(/\s+/g, '-').length;
      if (splitStr > 19) {
        setPinFormat(true);
      } else {
        setPinFormat(false);
      }
      setFormData({
        tdn: dataInfo.tdn,
        pin: dataInfo.pin,
        year: dataInfo.year,
        account_number: dataInfo.account_number,
        account_name: dataInfo.account_name,
        date_processed: moment(dataInfo.date_processed).format('MM-DD-YYYY'),
        expiration_date: moment(dataInfo.expiration_date).format('MM-DD-YYYY'),
        first_quarter:
          parseFloat(parseFloat(dataInfo.amount.replace(/,/g, ''))) *
          parseFloat(0.25),
        second_quarter:
          parseFloat(parseFloat(dataInfo.amount.replace(/,/g, ''))) *
          parseFloat(0.5),
        third_quarter:
          parseFloat(parseFloat(dataInfo.amount.replace(/,/g, ''))) *
          parseFloat(0.75),
        fourth_quarter: parseFloat(dataInfo.amount.replace(/,/g, '')),
        is_delinquent: dataInfo.is_delinquent,
        is_overwrite: dataInfo.is_overwrite,
        amount: parseFloat(dataInfo.amount.replace(/,/g, '')),
        mode_of_payment_1: dataInfo.mode_of_payment_1,
        mode_of_payment_2: dataInfo.mode_of_payment_2,
      });
    }
  }, [dataInfo]);

  const MAX_VAL = 9999999999999999.99;
  const withValueCap = inputObj => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };

  return (
    <Modal.Body className="p-4">
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6 form-group form-group-record px-2">
            <label htmlFor="last_name" className="form-label mb-0">
              Tax Declaration Number (TDN) {validateForm.renderMessage('tdn')}
            </label>
            {_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT') && (
              <input
                className="form-control text-uppercase form-input-record"
                placeholder="Enter your Tax Declaration Number"
                id="tdn"
                name="tdn"
                autoComplete="none"
                onChange={onChange}
                value={
                  (_.get(formData, 'tdn') &&
                    _.get(formData, 'tdn').toUpperCase()) ||
                  ''
                }
              />
            )}
            {!_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT') && (
              <InputMask
                placeholder={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}
                className="form-control text-uppercase form-input-record"
                maskChar=" "
                mask={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}
                autoComplete="none"
                id="tdn"
                name="tdn"
                onChange={onChange}
                value={
                  (_.get(formData, 'tdn') &&
                    _.get(formData, 'tdn').toUpperCase()) ||
                  ''
                }
              />
            )}
          </div>
          <div className="col-6 form-group form-group-record px-2">
            <div className="d-flex justify-content-between">
              <label htmlFor="last_name" className="form-label mb-0">
                Property Identification Number (PIN){' '}
                {validateForm.renderMessage('pin')}
              </label>
              {_.get(CMS_COMPONENTS, 'RPTAX_HAS_SECOND_FORMAT_TAGGING') ===
                true && (
                <div>
                  <label className="form-label mb-0">
                    {_.get(CMS_COMPONENTS, 'RPTAX_SECOND_FORMAT_TAGGING_LABEL')}
                    <input
                      className="ml-1"
                      name="pinFormat"
                      type="checkbox"
                      checked={pinFormat}
                      onChange={handlePinFormat}
                    />
                  </label>
                </div>
              )}
            </div>

            <InputMask
              placeholder={
                pinFormat
                  ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV')
                  : // ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2')
                    _.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')
                // : _.get(CMS_MASKINGS, 'RPTAX_PIN')
              }
              className="form-control form-input-record"
              maskChar=" "
              mask={
                pinFormat
                  ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV')
                  : // ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2')
                    _.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')
                // : _.get(CMS_MASKINGS, 'RPTAX_PIN')
              }
              autoComplete="none"
              id="pin"
              name="pin"
              onChange={onChange}
              value={
                (_.get(formData, 'pin') &&
                  _.get(formData, 'pin').toUpperCase()) ||
                ''
              }
            />
          </div>
          {_.get(CMS_COMPONENTS, 'RPTAX_PIN_INPUT_FREE_TEXT') && (
            <div className="col-6 form-group form-group-record px-2">
              <label htmlFor="last_name" className="form-label mb-0">
                Property Identification Number (PIN){' '}
                {validateForm.renderMessage('pin')}
              </label>
              <input
                className="form-control form-input-record"
                placeholder="Enter your Property Identification Number"
                id="pin"
                name="pin"
                autoComplete="none"
                onChange={handleOnChange}
                value={
                  (_.get(formData, 'pin') &&
                    _.get(formData, 'pin').toUpperCase()) ||
                  ''
                }
              />
            </div>
          )}
          <div className="col-6 form-group form-group-record px-2">
            <label htmlFor="last_name" className="form-label mb-0">
              Account Number {validateForm.renderMessage('account_number')}
            </label>
            {_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT') && (
              <input
                className="form-control text-uppercase form-input-record"
                placeholder="Enter Account Number"
                id="account_number"
                name="account_number"
                autoComplete="none"
                onChange={onChange}
                value={
                  (_.get(formData, 'account_number') &&
                    _.get(formData, 'account_number').toUpperCase()) ||
                  ''
                }
              />
            )}
            {!_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT') && (
              <InputMask
                placeholder={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}
                className="form-control text-uppercase form-input-record"
                maskChar=" "
                mask={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}
                autoComplete="none"
                id="account_number"
                name="account_number"
                onChange={onChange}
                value={
                  (_.get(formData, 'account_number') &&
                    _.get(formData, 'account_number').toUpperCase()) ||
                  ''
                }
              />
            )}
          </div>
          <div className="col-6 form-group form-group-record px-2">
            <label className="form-label mb-0">
              Account Name {validateForm.renderMessage('account_name')}
            </label>
            <input
              className="form-control text-uppercase form-input-record"
              type="text"
              name="account_name"
              onChange={handleOnChange('account_name')}
              value={
                _.get(formData, 'account_name') &&
                _.get(formData, 'account_name').toUpperCase()
              }
            />
          </div>
          <div className="form-group col-6 form-group-record px-2">
            <label className="form-label mb-2 form-label-record">
              Billing Date {validateForm.renderMessage('date_processed')}
            </label>
            <DateInputPicker
              inputClassName="full-input form-input-record"
              btnClassName="button-date2 cms-bg-color-primary cms-outline-primary"
              onChange={handleOnChangeDate('date_processed')}
              value={_.get(formData, 'date_processed') || ''}
            />
          </div>
          <div className="form-group col-6 form-group-record px-2">
            <label className="form-label mb-2 form-label-record">
              Expiration Date {validateForm.renderMessage('expiration_date')}
            </label>
            <DateInputPicker
              inputClassName="full-input form-input-record"
              btnClassName="button-date2 cms-bg-color-primary cms-outline-primary"
              onChange={handleOnChangeDate('expiration_date')}
              value={_.get(formData, 'expiration_date') || ''}
            />
          </div>
          <div className="col-6 form-group form-group-record px-2">
            <label className="form-label mb-2 form-label-record">
              SOA Amount {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="_"
              className="form-control text-uppercase form-input-record"
              onValueChange={values => {
                const { formattedValue, floatValue } = values;
                // floatValue = ""
                // const updatedAmount = floatValue >= 5 &&  floatValue <= 10000

                const isDecimal =
                  floatValue && /^\d{1,}(\.\d{0,4})?$/.test(floatValue);

                // SOA Amount computation
                if (isDecimal) {
                  setFormData(prevFormData => ({
                    ...prevFormData,
                    amount: formattedValue || '',
                    first_quarter: parseFloat(floatValue) * parseFloat(0.25),
                    second_quarter: parseFloat(floatValue) * parseFloat(0.5),
                    third_quarter: parseFloat(floatValue) * parseFloat(0.75),
                    fourth_quarter: floatValue,
                  }));
                }
              }}
              isAllowed={withValueCap}
              isNumericString
              thousandSeparator
              allowNegative
              allowLeadingZeros
              displayType="input"
              prefix=""
              value={_.get(formData, 'amount', '') || ''}
            />
          </div>
          {_.get(CMS_COMPONENTS, 'RPTAX_AUTOMATIC_PERIOD') === true && (
            <div className="col-6 form-group form-group-record px-2 py-3 mb-2">
              <div
                className="w-100 p-3"
                style={{
                  background: '#F2F7FF',
                  border: '1px dashed #4C6085',
                  borderRadius: '7px',
                }}
              >
                <table className="table-borderless table-sm w-100">
                  <thead>
                    <tr>
                      <th> Period From - To </th>
                      {!_.isEmpty(_.get(formData, 'date_processed')) && (
                        <th>
                          {' '}
                          {_.get(formData, 'date_processed')} -{' '}
                          {_.get(formData, 'expiration_date')}{' '}
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="py-1">1st Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'first_quarter')
                          ? parseFloat(
                              _.get(formData, 'first_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                    <tr>
                      <td className="py-1">2nd Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'second_quarter')
                          ? parseFloat(
                              _.get(formData, 'second_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                    <tr>
                      <td className="py-1">3rd Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'third_quarter')
                          ? parseFloat(
                              _.get(formData, 'third_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                    <tr>
                      <td className="py-1">4th Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'fourth_quarter')
                          ? parseFloat(
                              _.get(formData, 'fourth_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="col-6 form-group form-group-record px-2">
            <label className="text-color-title mr-1 align-self-center form-label-record">
              Year {validateForm.renderMessage('year')}
            </label>
            <div className="w-auto mr-3">
              <Select
                styles={reactSelectCustomStyleCms()}
                placeholder="Select Year"
                value={
                  getYearsList().filter(
                    item =>
                      `${item.value}` ===
                      `${
                        _.get(formData, 'year')
                          ? moment(_.get(formData, 'year')).format('YYYY')
                          : ''
                      }`
                  )[0]
                }
                options={getYearsList()}
                onChange={handleOnChangeSelect('year')}
              />
            </div>
          </div>
          {_.get(CMS_COMPONENTS, 'RPTAX_MODE_OF_PAYMENT') === true && (
            <>
              <div className="form-group col-6 form-group-record px-2">
                <label className="form-label mb-2 form-label-record">
                  Period From
                </label>
                <input
                  className="form-control form-input-record"
                  id="mode_of_payment_1"
                  name="mode_of_payment_1"
                  disabled
                  value={_.get(formData, 'mode_of_payment_1')}
                />
              </div>
              <div className="form-group col-6 form-group-record px-2">
                <label className="form-label mb-2 form-label-record">
                  Period To
                </label>
                <input
                  className="form-control form-input-record"
                  id="mode_of_payment_2"
                  name="mode_of_payment_2"
                  disabled
                  value={_.get(formData, 'mode_of_payment_2')}
                />
              </div>
            </>
          )}
          <div className="col-6 form-group form-group-record px-2">
            <label className="text-color-title form-label-record">Select</label>
            <div className="row-nav">
              <div className="div-overwrite">
                <div className="mr-2">
                  <input
                    name="is_overwrite"
                    type="checkbox"
                    className="check-box"
                    checked={_.get(formData, 'is_overwrite')}
                    onChange={onChange}
                  />
                </div>
                <label className="mb-0">Overwrite</label>
              </div>
              <div className="div-del">
                <div className="mr-2">
                  <input
                    name="is_delinquent"
                    type="checkbox"
                    className="check-box"
                    checked={_.get(formData, 'is_delinquent')}
                    onChange={onChange}
                  />
                </div>
                <label className="mb-0">Delinquent</label>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddRecordModal.defaultProps = {
  type: '',
  dataInfo: {},
  id: '',
};

AddRecordModal.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createRecord: PropTypes.instanceOf(Function).isRequired,
  updateRecord: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  creating: PropTypes.bool.isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_RECORD) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddRecordModal);
